<template>
  <div :id="uid"
    :style="(filterMode == 'ALL' || filterMode == 'PLUZZ') ? 'display: block' : ((module_stats) ? 'display: block' : 'display: none')"
    :class="(viewMode == 'GROUP') ? cssClass : 'cfa-module col-12 mb-4'" class="module-box">

    <div :id="uid + '-content'"
      :class="(viewMode == 'GROUP') ? 'p-3 bg-white cfa-course-module-inner cfa-module-shadow' : 'p-3 bg-white cfa-course-module-inner d-flex flex-row cfa-module-shadow'">
      <div>
        <div class="cfa-module-image-1 position-relative">
          <img :src="preview" alt="cfa module course image" />
          <button style="text-transform: uppercase;" class="gType btn btn-discret cfa-btn-primary">{{ type }}</button>
        </div>
      </div>
      <div :class="(viewMode == 'GROUP') ? '' : 'ms-3 w-100'">
        <div class="py-3">
          <button class="btn btn-discret cfa-btn-primary no-wrapping d-flex gap-1" style="width:fit-content">
            <img width="10" src="../../../assets/Icons/All_Icon/Vector-7.png" alt="cfa assets" />
            {{ label }}
          </button>
        </div>
        <div class="py-2">
          <h2 style="width: 80%; font-size: 1.1em; font-weight: bolder; display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.4; min-height: 5.6em;">{{ title }}</h2>
        </div>
        <!-- <div class="py-2 pb-3" style="height: 5em; overflow: hidden;" v-html="description"></div> -->
        <div class="py-2 pt-4">
          <c-f-a-progress v-if="module_stats != null"
            :percent="(module_stats?.progression == 0) ? 1 : module_stats?.progression" :active="true">
          </c-f-a-progress>
          <c-f-a-progress v-else-if="module_pluzz_stats != null"
            :percent="(module_pluzz_stats?.progression == 0) ? 1 : module_pluzz_stats?.progression"
            :active="true"></c-f-a-progress>
          <c-f-a-progress v-else :percent="0" :active="false"></c-f-a-progress>
        </div>
        <div class="py-2 pb-0 d-flex align-items-center justify-content-between">
          <div class="no-wrapping d-flex gap-1">
            <img width="15" src="../../../assets/img/png/timer.png" />
            {{ max__horaire }} <!-- minutes -->
          </div>
          <!-- Modules Pluzz -->
          <template v-if="filterMode === 'PLUZZ'">
            <a v-if="module_pluzz_stats != null && module_pluzz_stats.progress == 100"
              :href="'/modules-pluzz-details/' + id">
              <button class="btn cfa-btn-gold d-flex">
                Reprendre&nbsp;<i class="fa fa-repeat white-color"></i>
              </button>
            </a>
            <a v-else-if="module_pluzz_stats != null" href="/toward-module-content">
              <button @click.prevent="continuePluzzModule" class="btn cfa-btn-primary d-flex">
                <span>Continuer</span>
                <i class="fa fa-arrow-right white-color"></i>
              </button>
            </a>
            <a v-else href="/toward-module-content">
              <button @click.prevent="initStat" v-if="remain_days != ''" class="btn cfa-btn-primary d-flex">
                <span>{{ $t('get_started') }}&nbsp;</span>
                <i v-if="!waitAPI" class="fa fa-arrow-right white-color"></i>
                <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 20px;" />
              </button>
              <button @click.prevent="initStat2" v-else class="btn cfa-btn-danger">
                {{ $t('get_started') }}
                <i v-if="!waitAPI" class="fa fa-arrow-right"></i>
                <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 20px;" />
              </button>
            </a>
          </template>

          <!-- Modules normaux -->
          <template v-else>
            <a v-if="module_stats != null && module_stats.progress == 100" :href="'/modules-details/' + id">
              <button class="btn cfa-btn-gold d-flex">
                Reprendre&nbsp;<i class="fa fa-repeat white-color"></i>
              </button>
            </a>
            <a v-else-if="module_stats != null" href="/toward-module-content">
              <button @click.prevent="continueModule" class="btn cfa-btn-primary d-flex">
                <span>Continuer</span>
                <i class="fa fa-arrow-right white-color"></i>
              </button>
            </a>
            <a v-else href="/toward-module-content">
              <button @click.prevent="initStat" v-if="remain_days != ''" class="btn cfa-btn-primary d-flex">
                <span>{{ $t('get_started') }}&nbsp;</span>
                <i v-if="!waitAPI" class="fa fa-arrow-right white-color"></i>
                <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 20px;" />
              </button>
              <button @click.prevent="initStat2" v-else class="btn cfa-btn-danger">
                {{ $t('get_started') }}
                <i v-if="!waitAPI" class="fa fa-arrow-right"></i>
                <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 20px;" />
              </button>
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CFAProgress from '@/components/shared/progress/CFAProgress.vue'
import { getAPI } from "@/axios-api";

export default {
  name: 'CourseCard',
  components: {
    CFAProgress
  },
  props: {
    uid: {
      type: String,
      default: 'cfa-course-01'
    },
    preview: {
      type: String,
      default: 'https://picsum.photos/300/201'
    },
    id: {
      type: String,
      default: '6de8547856985412254dj44522'
    },
    label: {
      type: String,
      default: 'Module 1'
    },
    type: {
      type: String,
      default: 'FORENSIC'
    },
    title: {
      type: String,
      default: 'Sécurité du post de travail.'
    },
    description: {
      type: String,
      default: '',
      required: false,
    },
    started: {
      type: Boolean,
      default: true
    },
    finished: {
      type: Boolean,
      default: false
    },
    max__horaire: {
      type: String,
      default: '22'
    },
    viewMode: {
      type: String,
      default: 'GROUP'
    },
    filterMode: {
      type: String,
      default: 'ALL'
    },
    cssClass: {
      type: String,
      default: 'cfa-module col-12 col-md-4 mb-4'
    },
    percent: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      userId: localStorage.getItem('user'),
      module_stats: null,
      module_pluzz_stats: null,
      waitAPI: false,
      subscriptionData: [],
      remain_days: "",
      userRole: localStorage.getItem("role")

    }
  },
  methods: {
    retrieveUserSubscription() {
      this.waitingAPIResponse = true
      getAPI.get(`subscriptions/find-subscription`).then(response => {
        if (response.status == 200) {
          this.subscriptionData = response.data.data

          if (this.subscriptionData != null) {
            console.log("Infos: ", this.subscriptionData)
          }

          this.remain_days = this.subscriptionData.remain_days

          const created_at = new Date(this.subscriptionData.created_at)
          created_at.setDate(created_at.getDate() + 30);

          const expirationDate = created_at.toISOString();

          this.expiration_date = expirationDate
        }
        else {
          //let msg = 'Oups ! something went wrong.'
          //this.alertString = `${msg}|alert-no|5000::`+Date.now()
        }
        setTimeout(() => {
          this.waitingAPIResponse = false
        }, 2000);
      }).catch(error => {
        if (error.response) {
          //this.alertString = `${error.response.data.message}|alert-no|10000::`+Date.now()
        }
        else if (error.request) {
          //let msg = 'The request was made but no response was received. Please check your network.'
          //this.alertString = `${msg}|alert-no|8000::`+Date.now()
        }
        else {
          //let msg = 'Oups ! something went wrong.'
          //this.alertString = `${msg}|alert-no|5000::`+Date.now()
        }
        this.waitingAPIResponse = false
      })
    },
    continueModule() {
      let a = document.createElement('a')
      a.setAttribute('href', `/modules-details/${this.id}`)
      a.click()
      a.remove()
    },

    continuePluzzModule() {
      let a = document.createElement('a')
      a.setAttribute('href', `/modules-pluzz-details/${this.id}`)
      a.click()
      a.remove()
    },

    initStat() {
      this.waitAPI = true
      if (this.filterMode === 'PLUZZ') {
        getAPI.post(`start_module_pluzz/`, {
          module_pluzz: this.id,
          user: this.userId,
        })
          .then(response => {
            console.log(response)
            if (response.status === 201) {
              this.getModulePluzzStats();
              let a = document.createElement('a')
              a.setAttribute('href', `/modules-pluzz-details/${this.id}`)
              a.click()
              a.remove()
            }
            this.waitAPI = false;
          })
          .catch(error => {
            console.log(error);
            const pattern = /\bmodules?\b/i;
            if (error.response.data?.message && pattern.test(error.response.data?.message)) {
              this.$swal({
                title: 'Modules',
                //text: (error.response.data.message == 'You are not valid subscription') ? "" : ((error.response.data.message == "Your previous module is not finished") ? "Vous devez terminé le module précédent avant d'en démarrer un autre !" : error.response.data.message),
                text: "Vous devez terminer le module précédent avant d'en démarrer un autre !",
                type: 'warning',
                showCancelButton: false,
                confirmButtonText: `Fermer`,
              });
            }
            this.waitAPI = false;
          })
      } else {
        getAPI.post(`stat_module/`, {
          module: this.id,
          user: this.userId,
          //progression: 1
        })
          .then(response => {
            console.log("Module: ", this.id, " User: ", this.userId)
            console.log(response)
            //return
            //return
            //eslint-disable-next-line
            if (response.status == 201) {
              this.getModuleStats();
              this.module_stats = (response.data.success) ? response.data.data : null;
              let a = document.createElement('a')
              a.setAttribute('href', `/modules-details/${this.id}`)
              a.click()
              a.remove()
            }
            this.waitAPI = false
          })
          .catch((error) => {
            console.log(error)

            /*this.getModuleStats();
            this.module_stats = (error.response.data.data.success) ? error.response.data.data : null;
            let a = document.createElement('a')
            a.setAttribute('href', `/modules-details/${this.id}`)
            a.click()
            a.remove()*/
            const pattern = /\bmodules?\b/i;
            if (error.response.data?.message && pattern.test(error.response.data?.message)) {

              this.$swal({
                title: 'Modules',
                //text: (error.response.data.message == 'You are not valid subscription') ? "" : ((error.response.data.message == "Your previous module is not finished") ? "Vous devez terminé le module précédent avant d'en démarrer un autre !" : error.response.data.message),
                text: "Vous devez terminer le module précédent avant d'en démarrer un autre !",
                type: 'warning',
                showCancelButton: false,
                confirmButtonText: `Fermer`,
              });
            }

            /*this.$swal('Hello Vue world!!!');
            //let msg = (error.response.data.message == 'You are not valid subscription') ? '<div style="display: flex;justify-content: space-between; align-items: center; position: relative; top: -0.3em; width: 30em;"><span>Vous n\'avez encore souscrire à aucun plan !</span><a href="/facturation"><button style="background-color: #06bbc4; color: #fff; transition: all ease-in .2s; outline: none; border: none; border-radius: 5px; padding: 0.1em 0.5em; padding-top: 0.5em;">SOUSCRIRE</button></a></div>' : error.response.data.message
            this.$emit('error', msg)*/
            // console.log('An error occur while loading module !')
            this.waitAPI = false
          })
      }
    },
    initStat2() {
      this.waitAPI = true
      if (this.filterMode === 'PLUZZ') {
        getAPI.post(`start_module_pluzz/`, {
          module_pluzz: this.id,
          user: this.userId,
        })
          .then(response => {
            console.log(response)
            if (response.status === 201) {
              this.getModulePluzzStats();
              let a = document.createElement('a')
              a.setAttribute('href', `/modules-pluzz-details/${this.id}`)
              a.click()
              a.remove()
            }
            this.waitAPI = false;
          })
          .catch(error => {
            console.log(error);
            this.waitAPI = false;
          })
      } else {
        getAPI.post(`stat_module/`, {
          module: this.id,
          user: this.userId,
          //progression: 1
        })
          .then(response => {
            console.log("Module: ", this.id, " User: ", this.userId)
            console.log(response)
            //return
            //eslint-disable-next-line
            if (response.status == 201) {
              this.getModuleStats();
              this.module_stats = (response.data.success) ? response.data.data : null;
              let a = document.createElement('a')
              a.setAttribute('href', `/modules-details/${this.id}`)
              a.click()
              a.remove()
            }
            this.waitAPI = false
          })
          .catch((error) => {
            this.$swal({
              title: 'Oups ! Vous n\'avez encore souscrit à aucun plan.',
              text: (error.response.data.message == 'You are not valid subscription') ? "" : ((error.response.data.message == "Your previous module is not finished") ? "Vous devez terminé le module précédent avant d'en démarrer un autre !" : error.response.data.message),
              type: 'warning',
              showCancelButton: false,
              confirmButtonText: this.userRole == 'manager' ? `<a href="/facturation/pricing" style="text-decoration: none; font-weight: 400; color: white;">Aller à la facturation</a>` : `<span>Fermer</span>`,
            });

            /*this.$swal('Hello Vue world!!!');
            //let msg = (error.response.data.message == 'You are not valid subscription') ? '<div style="display: flex;justify-content: space-between; align-items: center; position: relative; top: -0.3em; width: 30em;"><span>Vous n\'avez encore souscrire à aucun plan !</span><a href="/facturation"><button style="background-color: #06bbc4; color: #fff; transition: all ease-in .2s; outline: none; border: none; border-radius: 5px; padding: 0.1em 0.5em; padding-top: 0.5em;">SOUSCRIRE</button></a></div>' : error.response.data.message
            this.$emit('error', msg)*/
            // console.log('An error occur while loading module !')
            this.waitAPI = false
          })
      }
    },
    async getModuleStats() {
      await getAPI.get(`stat_module/user/${this.userId}/${this.id}/`).then(response => {
        console.log(response)
        if (response.status == 200) {
          this.module_stats = (response.data.success) ? response.data.data : null;
        }
      }).catch((err) => {
        console.log(err)
        console.log('An error occur while loading module !')
      })
    },
    async getModulePluzzStats() {
      await getAPI.get(`start_module_pluzz/user/${this.userId}/${this.id}/`).then(response => {
        console.log('Module Pluzz stats:', response);
        if (response.status === 200) {
          this.module_pluzz_stats = (response.data.success) ? response.data.data : null;
        }
      }).catch((err) => {
        // Si c'est une 404 ou 500, c'est normal - le module n'a simplement pas encore été démarré
        // On laisse module_pluzz_stats à null pour afficher le bouton "Démarrer"
        console.log('Pas de stats pour ce module Pluzz (pas encore démarré)');
        console.log(err);
        this.module_pluzz_stats = null;
      });
    }
  },
  watch: {
  },
  mounted() {
    console.log(this.filterMode);
    if (this.filterMode === "PLUZZ") {
      this.getModulePluzzStats();
    }
    else {
      this.getModuleStats();
    }
    this.retrieveUserSubscription();
  }
}
</script>

<style lang="scss" scoped>
.cfa-course-module-inner {
  border-radius: .5em;
}

.module-list {
  min-width: 100%;
}

.cfa-module-image-1 {
  /* width: 500px; */
  border: 2px solid #f0f1f6;
  border-radius: .5em;
  overflow: hidden;
  //min-height: 16em;
  min-height: 100%;
  background-color: var(--primary-light-color-2);
}

.cfa-module-image-1 img {
  width: 100%;
  /* min-width: 320px; */
  height: 100%;
  min-height: 100%;
  /* max-height: 260px; */
  transition: all ease-in .3s;
  color: var(--primary-light-color-2);
}

.cfa-module-image-1 img:hover {
  transform: scale(1.2) !important;
}

.gType {
  position: absolute;
  top: 0.5em;
  left: 0.5em;
}

.cfa-module {
  transition: all ease-in .3s;
}

.cfa-module-shadow {
  /* box-shadow: 20px 12px 109px -37px rgba(0,0,0,0.87);
  -webkit-box-shadow: 20px 12px 109px -37px rgba(0,0,0,0.87);
  -moz-box-shadow: 20px 12px 109px -37px rgba(0,0,0,0.87); */
  box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);
  -webkit-box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);
  -moz-box-shadow: -1px 1px 29px 20px rgba(222, 234, 250, 0.87);
}

.module-box {
  width: 100%;
  //min-width: 100%;
  max-width: 100%;

  @media (min-width: 576px) {
    max-width: 320px !important;
  }

  @media (min-width: 768px) {
    max-width: 340px !important;
  }

  @media (min-width: 992px) {
    max-width: 360px !important;
  }
}
</style>
